import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Paper, Typography, Tabs, Tab, IconButton } from '@mui/material';
import { ArrowBack } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import config from '../config.js';
import Saldo from '../components/common/Saldo.js';
import DataLoader from '../components/common/DataLoader.js';
import useBack from '../hooks/useBack.js';
import MovimentsListEdit from '../components/common/MovimentsListEdit.js';

const DashboardTipusMoviment = () => {
  const [reloadId, setReloadId] = useState(0);
  const { userapp: paramUserapp, concepte: paramConcepte, tipusMov: paramTipusMov } = useParams();
  const userapp = paramUserapp;
  const concepte = paramConcepte;
  const tipusMov = paramTipusMov;
  const id = concepte + '-' + tipusMov + '-' + reloadId;

  const { onBack } = useBack();

  const gotoBack = () => {
    //navigate(`/${userapp}/dashboard/${anyo}`);
    onBack();
  }; 

  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/resumglobalconcepte/${userapp}/${concepte}/movs`, {
      headers: { Authorization: `${jwtToken}`},
      params: { nomMoviment: `${tipusMov}`}
    })
    .then((response) => {
      onData(response);
    })
    .catch((err) => {
      onError(err, 'cargar datos');
    })
    .finally(() => onFinally());
  };

  const calculaImportAgregat = (list) => {
      let ingresos=0.0, despeses=0.0, saldo=0.0;
      for(const conc of list) {
        saldo = saldo + conc.importe;
        if(conc.importe > 0) {
          ingresos = ingresos + conc.importe;
        }

        if(conc.importe < 0) {
            despeses = despeses + conc.importe;
        }
      }

      return {
        id: `${userapp}|${concepte}|${tipusMov}`,
        numMoviments: list.length,
        ingressos: ingresos,
        despeses,
        saldo
      };
;
  };

  return (
    <DataLoader 
      id={id} 
      fetchFunction={fetchFunction} 
      goBackLocation={`/${userapp}/dashboard/concepte/${concepte}/tipusmov/${tipusMov}`} 
    >
      {(data, onError) => {
        const importAgregat = calculaImportAgregat(data);

        return (
        <>
          <Grid 
            size={{xs: 12, sm: 6 }} 
            sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}
          >
            <IconButton onClick={()=>gotoBack()}>
              <ArrowBack />
            </IconButton>

            <Typography variant="h5">
              Dashboard Tipus Moviment Concepte
            </Typography>
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: '10px' }}>
            <Saldo titol="Saldo Global Tipus Moviment" 
              saldo={importAgregat.saldo} 
              ingressos={importAgregat.ingressos}
              despeses={importAgregat.despeses} />
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: '10px' }}>
            {/* Tabbar */}
            <Grid size={12}>
              <Paper>
                <Tabs value={0} indicatorColor="primary" textColor="primary" centered>
                  <Tab label="Moviments" />
                </Tabs>
                <MovimentsListEdit moviments={data} onError={onError} onEditComplete={() => setReloadId(prev => prev + 1)}/>
              </Paper>
            </Grid>
          </Grid>
      </>
      );
    }}
    </DataLoader>
  );
};

export default DashboardTipusMoviment;
